import { fetcher } from '@commenda/utils';

export async function deleteExemptionCertificate(
  certificateId: string,
  corporationId: number
): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/${certificateId}?corporation_id=${corporationId}`,
      { method: 'DELETE' },
      undefined
    );

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to delete exemption certificate',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error:
        'An unexpected error occurred while deleting the exemption certificate',
    };
  }
}

export async function deleteJurisdictionExemption(
  certificateId: string,
  jurisdictionId: string,
  corporationId: number
): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/${certificateId}/jurisdictions/${jurisdictionId}?corporation_id=${corporationId}`,
      { method: 'DELETE' },
      undefined
    );

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to delete jurisdiction exemption',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: 'An unexpected error occurred while deleting the exemption',
    };
  }
}
